import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { setPageFilters, clearPageFilters } from "src/redux/slices/filters";

export function usePersistedFilters(pageKey: string) {
  const dispatch = useAppDispatch();
  const persisted = useAppSelector(
    (state: any) => state.root?.filters?.pages?.[pageKey] ?? null,
  );

  const saveFilters = useCallback(
    (data: Record<string, any>) => {
      dispatch(setPageFilters({ pageKey, filters: data }));
    },
    [pageKey, dispatch],
  );

  const clearFilters = useCallback(() => {
    dispatch(clearPageFilters(pageKey));
  }, [pageKey, dispatch]);

  return { persisted, saveFilters, clearFilters };
}
